export const White = '#FFFFFF';
